<template>
  <div class="error-view">
    <div class="">
      <img :src="`${baseUrl}images/404.png`">
      <div class="mt10 flex-box al-c">
        <span class="red mr10" style="font-size: 50px">404</span>
        <div class="flex-1">
          <p class="font-24">该页面已经不知飘去何处了！</p>
          <p class="font-14 grey">您可能输错了地址</p>
        </div>
      </div>
      <div class="mt20 tx-c">
        <el-button style="width: 130px;" type="primary" @click="goHome">返回首页</el-button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Error",
  props: [],
  components: {},
  data() {
    return {
      baseUrl: process.env.BASE_URL
    };
  },
  computed: {},
  created() {},
  mounted() {},
  destroyed() {},
  methods: {
    goHome() {
      this.$router.push("/");
    }
  },
  watch: {},
  filters: {}
};
</script>

<style scoped>
.error-view {
  width: 100%;
  height: calc(100vh - 90px);
  display: flex;
  align-items: center;
  justify-content: center;
  background: #fafafa;
}
</style>
